import React, { useEffect, useState } from "react";
import * as S from "./styles";
import Button from "../../components/Button";
import Parameter from "../../services/parameter";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";

export default function EditParameterPoPup({
  setOpenPopup,
  parameterSelected,
  updateList,
  setIsLoading,
  page,
}) {
  const [newValue, setNewValue] = useState(parameterSelected?.valor || "");

  useEffect(() => {
    setIsLoading(false);
  }, [parameterSelected]);

  const handleEditParameter = async () => {
    if (!newValue || newValue.length === 0) {
      toast.error("Informe o novo valor!");

      return;
    }

    try {
      const dataSending = { id: parameterSelected?.id, valor: newValue };

      const response = await Parameter.editValue(
        parameterSelected?.id,
        dataSending
      );

      if (response.status === 204 || response.status === 200) {
        toast.success("Parâmetro editado com sucesso!");
      } else if (!response) {
        toast.error("Erro ao editar o parâmetro!");
      }

      setOpenPopup(false);
      updateList(page);
    } catch (err) {
      setOpenPopup(false);
      if (err?.response?.data?.message) {
        toast.error(err?.response?.data?.message);
      } else {
        toast.error("Erro ao editar o parâmetro!");
      }
    } finally {
      setOpenPopup(false);
    }
  };

  return (
    <>
      <S.PopupBackground>
        <S.PopupContainer>
          <S.TitleCloseBtn>
            <button
              onClick={() => {
                setOpenPopup(false);
              }}
            >
              <IoClose />
            </button>
          </S.TitleCloseBtn>

          <S.Label>Chave:</S.Label>
          <S.BodyTitle>
            <p>{!!parameterSelected && parameterSelected?.chave}</p>
          </S.BodyTitle>

          <S.Label>Descrição:</S.Label>
          <S.BodyTitle>
            <p>{!!parameterSelected && parameterSelected?.descricao}</p>
          </S.BodyTitle>

          <S.Label>Entre com o novo valor:</S.Label>
          {parameterSelected?.tipoParametroValor === "BOOLEAN" ? (
            <S.ClassInput>
              <S.InputRadio
                type="radio"
                id="sim"
                name="radioSim"
                value="Sim"
                checked={newValue === "1"}
                onChange={() => {
                  setNewValue("1");
                }}
              ></S.InputRadio>
              <S.LabelInput>Sim</S.LabelInput>
              <S.InputRadio
                type="radio"
                id="nao"
                name="radioNao"
                value="Não"
                checked={newValue === "0"}
                onChange={() => {
                  setNewValue("0");
                }}
              ></S.InputRadio>
              <S.LabelInput>Não</S.LabelInput>
            </S.ClassInput>
          ) : parameterSelected?.tipoParametroValor === "INTEGER" ? (
            <S.Input
              type="number"
              id="inputValue"
              placeholder="Digite o valor desejado"
              value={newValue}
              onChange={(e) => {
                setNewValue(e.target.value);
              }}
            />
          ) : (
            <S.Input
              type="text"
              id="inputValue"
              placeholder="Digite o valor desejado"
              value={newValue}
              onChange={(e) => {
                setNewValue(e.target.value);
              }}
            />
          )}

          <S.Footer>
            <Button onClick={() => handleEditParameter()}>Editar</Button>
          </S.Footer>
        </S.PopupContainer>
      </S.PopupBackground>
    </>
  );
}
